<!-- Accessibility TODO: Complex interactive forms are not recommended inside a menu. Convert into a dialog instead -->
<div class="search-container" [style.display]="display === 'block' ? 'flex' : 'inline'">
  <div>
    <mat-form-field class="search-box" appearance="outline" *ngIf="!hideSearch">
      <mat-icon matIconPrefix>search</mat-icon>
      <mat-label>{{ searchLabel || 'Contacts.List.Search' | translate: locale.language }}</mat-label>
      <input matInput [formControl]="searchForm" [attr.data-test]="'search'" />
      <button
        mat-icon-button
        matIconSuffix
        *ngIf="searchForm.value"
        (click)="searchForm.setValue('')"
        [attr.aria-label]="'Clear' | translate: locale.language">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    @switch (type) {
      @case ('button') {
        @if (display === 'inline') {
          <mat-chip-set>
            <ng-container *ngTemplateOutlet="appliedFiltersChips"></ng-container>
          </mat-chip-set>
        }
        <button
          name="filter-button"
          mat-flat-button
          [matTooltip]="'Filter.Tooltip' | translate: locale.language"
          [matMenuTriggerFor]="unappliedFilterMenu"
          [attr.data-test]="'filter-button'">
          <mat-icon>filter_list</mat-icon>
          <span style="margin-left: 0.25rem">
            {{ 'Filter.Filters' | translate: locale.language }}
            <span *ngIf="appliedFilters?.length > 0"> ({{ appliedFilters?.length }}) </span>
          </span>
        </button>
      }
      @case ('chip') {
        <mat-chip-set>
          @if (display === 'inline') {
            <ng-container *ngTemplateOutlet="appliedFiltersChips"></ng-container>
          }
          @if (availableFilters().length > 0) {
            <mat-chip
              class="empty"
              style="vertical-align: middle"
              name="filter-chip"
              [matMenuTriggerFor]="unappliedFilterMenu"
              [attr.data-test]="'filter-chip'">
              <mat-icon matChipAvatar>add</mat-icon>
              <span>
                {{ 'Add Filter' | translate: locale.language }}
              </span>
            </mat-chip>
          }
        </mat-chip-set>
      }
    }
    <mat-menu class="{{ constrainFilterMenu ? 'short' : '' }}" #unappliedFilterMenu="matMenu" role="dialog">
      @for (filter of availableFilters(); track $index) {
        <button
          mat-menu-item
          [matMenuTriggerFor]="filteredSearchMenu"
          [matMenuTriggerData]="{ filter: filter }"
          [attr.data-test]="'filter-menu-option-' + filter.field">
          {{ filter.localizedLabel | translate: locale.language }}
        </button>
      } @empty {
        <button mat-menu-item disabled [attr.data-test]="'filter-menu-option-empty'">
          {{ 'No Filters Available' | translate: locale.language }}
        </button>
      }
    </mat-menu>
    <mat-menu #filteredSearchMenu="matMenu" class="full-height" role="dialog">
      <ng-template matMenuContent let-filterField="filter">
        @if (filterField.type === 'daterange-menu') {
          @for (option of filterField.values; track option.value) {
            <button mat-menu-item (click)="onApplyFilter(filterField.field, option.value)">
              @if (option.icon) {
                <mat-icon>{{ option.icon }}</mat-icon>
              }
              {{ option.label }}
            </button>
          }
          <button mat-menu-item (click)="openCustomDateDialog(filterField)">
            <mat-icon>date_range</mat-icon>
            {{ 'Custom' | translate: locale.language }}
          </button>
        } @else {
          <app-filtered-search-option
            (filter)="onApplyFilter(null, null, { emitFilterChange: true, emitFiltersChange: true })"
            (closed)="closeCurrentMenu()"
            [singleFilter]="filterField"
            [form]="unappliedFilter"
            [availableFilters]="availableFilters()"
            mode="create">
          </app-filtered-search-option>
        }
      </ng-template>
    </mat-menu>
  </div>
  @if (display === 'block') {
    <div>
      <mat-chip-set>
        <ng-container *ngTemplateOutlet="appliedFiltersChips"></ng-container>
      </mat-chip-set>
    </div>
  }
</div>

<ng-template #appliedFiltersChips>
  @if (appliedFilters?.length) {
    @for (filter of appliedFilters.controls; track filter.value.field) {
      @if (!isHidden(filter.value.field)) {
        <mat-chip
          highlighted
          color="primary"
          [disabled]="!canRemove(filter.value.field)"
          [removable]="canRemove(filter.value.field)"
          (auxclick)="$event.button === 1 ? onRemoveFilter(filter.value.field) : null"
          (removed)="onRemoveFilter(filter.value.field)"
          [matMenuTriggerFor]="appliedFilterMenu"
          [attr.data-test]="'active-filter-' + filter.value.field">
          {{ getLocalizedLabel(filter.value.field) }}:
          {{ getValue(filter.value.field, filter.getRawValue().value) | maxCharacters: 30 | maxItems: 3 }}
          @if (filter.dirty) {
            <span
              class="dirty-filter-indicator"
              [matTooltipDisabled]="!filter.dirty"
              [matBadgeHidden]="!filter.dirty"
              matTooltip="Updated filter has not been applied"
              matBadgeDescription="Updated filter has not been applied"
              matBadge="*"
              matBadgeSize="small"
              matBadgeColor="warn"
              matBadgePosition="above"
              matTooltipPosition="above"></span>
          }
          <button
            matChipRemove
            [attr.data-test]="'remove-filter-' + filter.value.field"
            [attr.aria-label]="'Remove ' + filter.value.field"
            [tabIndex]="0">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
        <mat-menu #appliedFilterMenu="matMenu" class="full-height" role="dialog">
          <ng-template matMenuContent>
            <app-filtered-search-option
              (filter)="onUpdateFilter($event)"
              (closed)="closeCurrentMenu()"
              [form]="filter"
              [availableFilters]="availableFilters(filter.value)"
              mode="update"></app-filtered-search-option>
          </ng-template>
        </mat-menu>
      }
    }
  }
</ng-template>


